import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({ service, index }) {
    return (
        <Link
            to={`/solutions#${service.id}`}
            data-testid={`service-card-${service.id}`}
            className="group relative block overflow-hidden bg-ink focus-visible:outline-gold"
        >
            <div className="relative aspect-[4/3] overflow-hidden">
                <img
                    src={service.image}
                    alt={service.alt}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
                <span
                    className="absolute left-5 top-5 font-heading text-sm font-bold tracking-[0.2em] text-gold"
                    aria-hidden="true"
                >
                    {String(index + 1).padStart(2, "0")}
                </span>
                <ArrowUpRight
                    size={22}
                    aria-hidden="true"
                    className="absolute right-5 top-5 text-white/0 transition-all duration-300 group-hover:text-gold"
                />
            </div>
            <div className="relative p-6 sm:p-7 border-t-2 border-gold/0 transition-colors duration-300 group-hover:border-gold">
                <h3 className="font-heading text-xl sm:text-2xl font-semibold text-white">
                    {service.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-gray-400">
                    {service.description}
                </p>
            </div>
        </Link>
    );
}
